module.exports = __webpack_public_path__ + "static/media/22ESCWA18.0d0e4996.jpg";